import React, { useState, useEffect } from 'react';
import  { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { api } from '../utils/endpoint.js'
import iconBack from '../images/trackdetail/ic_back.svg'
import iconActive from '../images/trackdetail/ic_status_active.svg'
import iconInActive from '../images/trackdetail/ic_status_inactive.svg'


import { CONTACT_TYPE } from '../utils/contact-type'
import { CAR_TYPE } from '../utils/car-type'
import { CLAIM_TYPE } from '../utils/claim-type'

import { convertEngDateToThai, convertEngNoDashDateToThai } from '../utils/convert-date-to-thai'
import { getTitles } from '../services/fetchTitles';

function TrackingDetailComponent(props) {

  const navigate = useNavigate();
  const [ referenceNo, setReferenceNo ] = useState(props.referenceNo)
  const [ oldReferenceNo, setOldReferenceNo ] = useState('')

  //รถประกัน หรือ คู่กรณี
  const [ suffererType, setSuffererType ] = useState('')
  //คำนำหน้า
  const [ customerTitleCode, setCustomerTitleCode ] = useState('')
  //ชื่อ นามสกุล
  const [ customerName, setCustomerName ] = useState('')
  //ชื่อ อู่ศูนย์
  const [ garageName, setGarageName ] = useState('')
  //เบอร์
  const [ customerTel, setCustomerTel ] = useState('')
  //Email
  const [ customerEmail, setCustomerEmail ] = useState('')
  //Line
  const [ customerLine, setCustomerLine ] = useState('')

  //ประเภทผู้มาติดต่อ
  const [ contactType, setContactType ] = useState('')

  //ประเภทการเคลม
  const [ documentType, setDocumentType ] = useState('')

  //ผู้รับมอบอำนาจ
  const [ isAttorney, setIsAttorney ] = useState(true )
  //ติดต่อในนามนิติ
  const [ isCompany, setIsCompany ] = useState(false )
  
  //เลขรับแจ้ง
  const [ notifyNo, setNotifyNo ] = useState('')

  //วันที่ส่ง
  const [ confirmDate, setConfirmDate ] = useState('')
  
  const [ arrayTitles, setArrayTitles ] = useState([])
  const [ titleCodeList, setTitleCodeList ] = useState([])

  const [ isStatus01, setIsStatus01 ] = useState('')
  const [ isStatus02, setIsStatus02 ] = useState('')
  const [ isStatus03, setIsStatus03 ] = useState('')
  const [ isStatus04, setIsStatus04 ] = useState('')
  const [ isStatus05, setIsStatus05 ] = useState('')
  const [ isStatus06, setIsStatus06 ] = useState('')
  const [ isStatus07, setIsStatus07 ] = useState('')
  const [ displayStatus, setDisplayStatus ] = useState([])
  

  useEffect(() => {
    window.scrollTo(0, 0)
    if(props.referenceNo !== "") {
      if (
        props.referenceNo.length == 11 && 
        oldReferenceNo != props.referenceNo) {
        setReferenceNo(props.referenceNo)
        callApiGetTracking(props.referenceNo)
      }
    }
   
  }, [props])

  useEffect(() => {
    const fetchData = async () => {
      const {arrayTitles, listTitles } = await getTitles()
      setTitleCodeList(listTitles)
      setArrayTitles(arrayTitles)
    }
    fetchData()

  },[])


  function gotoBack(){
    navigate("/track")
  }



  async function callApiGetTracking( ref_no ) {

    setOldReferenceNo(ref_no)
    setIsStatus01('')
    setIsStatus02('')
    setIsStatus03('')
    setIsStatus04('')
    setIsStatus05('')
    setIsStatus06('')
    setIsStatus07('')
    
    await fetch(api.nonemcs.tracking(`ref_no=${ref_no}`))
    .then(response => response.json())
    .then(data => onSuccessCallApiGet(data), (error) => {
      if (error) {
        onFailCallApiGet(error )
      }
    });
  }
  async function onSuccessCallApiGet( data ){
    if(data) {  
      setNotifyNo(data.notify_number)
      setConfirmDate(data.confirmFormDate)
      setDocumentType(data.claim_type)
      setSuffererType(data.sufferer_type)
      setCustomerTitleCode( data.contact_title_code)
      setCustomerName(data.contact_name)
      setGarageName(data.garage_name )
      setCustomerTel(data.phone_number )
      setCustomerEmail(data.email )
      setCustomerLine( data.line_id )
      setContactType( data.contact_type)
      setIsAttorney(data.assignee)
      setIsCompany(data.legal_entity)

      const status_claims = data.status_claims
      let status1 = false
      let status2 = false
      let status3 = false
      let status4 = false
      let status5 = false
      let status6 = false
      let status7 = false
      setDisplayStatus([1,2,3,4,5])
      for (let i = 0; i < status_claims.length; i++) {
        const status = status_claims[i]
        if (status.status_id == '01') {
          status1 = true
          setIsStatus01(convertEngNoDashDateToThai(status.date)+', '+status.time)
        } 
        else if (status.status_id == '02') {
          status2 = true
          setIsStatus02(convertEngNoDashDateToThai(status.date)+', '+status.time)
        } 
        else if (status.status_id == '03') {
          status3 = true
          setIsStatus03(convertEngNoDashDateToThai(status.date)+', '+status.time)
        } 
        else if (status.status_id == '04') {
          status4 = true
          if (status4 && !status3) {
            setIsStatus03(' ')
          }
          setIsStatus04(convertEngNoDashDateToThai(status.date)+', '+status.time)
        }
        else if (status.status_id == '05') {
          status5 = true
          setIsStatus05(convertEngNoDashDateToThai(status.date)+', '+status.time)
        }
        else if (status.status_id == '06') {
          setDisplayStatus([1,6])
          status6 = true
          setIsStatus06(convertEngNoDashDateToThai(status.date)+', '+status.time)
        }
        else if (status.status_id == '07') {
          setDisplayStatus([1,2,3,7])
          status7 = true
          setIsStatus07(convertEngNoDashDateToThai(status.date)+', '+status.time)
        }
      }

      
    } else {
      gotoBack()
    }

  }
  async function onFailCallApiGet( error ){
    gotoBack()
  }


 
  function getCustomerTypeDesc(assignee, legal_entity) {
    let result = '';
    if (legal_entity === 'Y') {
      result += 'นิติบุคคล';
    }
    if (assignee === 'Y') {
      if (result.length > 0) {
        result += ' / ';
      }
      result += 'ผู้รับมอบอำนาจ';
    }
    return result.length > 0 ? result : '-';
  }
  return (
    <div className='flex-wrap w-full bg-white  p-4 md:p-8 '>
    
      { /* if desktop hidden */}
      <div className='flex lg:hidden flex-wrap  w-full'>
        <img onClick={gotoBack} src={iconBack} alt="back-page" />
      </div>

      <div className='flex-wrap w-full mt-6'>
        
        <span className='flex w-full text-xs md:text-sm font-normal not-italic leading-4 md:leading-5 text-green-500'>{referenceNo}</span>
        <span className='flex w-full text-xl md:text-2xl font-medium leading-7 md:leading-8'>ติดตามการเรียกร้องสินไหมทดแทน</span>
        <div className='flex flex-wrap w-full mt-2'>
          <div className='flex'>
            <span className=' text-xs md:text-sm font-normal leading-4 md:leading-5 text-grey-600'>แจ้งเมื่อวันที่ { convertEngDateToThai( moment(confirmDate).format('DD/MM/YYYY')) }</span>
          </div>
          <div className='flex items-center px-1'>
            <span className='font-normal text-[4px] md:text-[8px] text-grey-600'>&#9679;</span>
          </div>
          <div className='flex'>
            <span className=' text-xs md:text-sm font-normal leading-4 md:leading-5 text-grey-600'>เลขที่ใบรับแจ้ง { notifyNo }</span>
          </div>
          
        </div>

      </div>

      <div className='flex-wrap w-full mt-8'>
        <span className='flex w-full text-lg font-medium leading-6 '>ข้อมูลผู้เรียกร้อง</span>
      </div>

      <div className='flex flex-wrap w-full mt-0 md:mt-6'>
        <div className='flex-wrap w-full md:w-1/3  mt-4 md:mt-0'>
          <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>ชื่อ-นามสกุล</span>
          <span className='flex w-full text-base font-medium leading-5 mt-1'>{ arrayTitles[customerTitleCode] } {customerName}</span>
        </div>
        { garageName ? 
          <div className='flex-wrap w-full md:w-1/3  mt-4 md:mt-0'>
            <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>ชื่อศูนย์บริการ/อู่/บริษัทรถยก</span>
            <span className='flex w-full text-base font-medium leading-5 mt-1'>{garageName}</span>
          </div>
          : ''
        }
      </div>

      <div className='flex flex-wrap w-full mt-0 md:mt-6'>
        <div className='flex-wrap w-full md:w-1/3  mt-4 md:mt-0'>
          <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>ประเภทรถ</span>
          <span className='flex w-full text-base font-medium leading-5  mt-1'>{ (parseInt(suffererType+'') == 0 ? 'รถประกัน' : 'รถคู่กรณี') }</span>
        </div>
        <div className='flex-wrap w-full md:w-1/3  mt-4 md:mt-0'>
          <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>ประเภทผู้มาติดต่อ</span>
          <span className='flex w-full text-base font-medium leading-5  mt-1'>{ CONTACT_TYPE(contactType) }</span>
        </div>
        <div className='flex-wrap w-full md:w-1/3  mt-4 md:mt-0'>
          <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>ติดต่อในนาม</span>
          <span className='flex w-full text-base font-medium leading-5  mt-1'>{ getCustomerTypeDesc(isAttorney, isCompany) }</span>
        </div>
      </div>

      <div className='flex flex-wrap w-full mt-0 md:mt-6'>
        <div className='flex-wrap w-full md:w-1/3  mt-4 md:mt-0'>
          <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>เบอร์โทรศัพท์</span>
          <span className='flex w-full text-base font-medium leading-5  mt-1'>{ customerTel === ''  ? '-' : customerTel }</span>
        </div>

        <div className='flex-wrap w-full md:w-1/3  mt-4 md:mt-0'>
          <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>อีเมล</span>
          <span className='flex w-full text-base font-medium leading-5 break-words  mt-1'>{ customerEmail === '' ? '-' : customerEmail  }</span>
        </div>
        <div className='flex-wrap w-full md:w-1/3  mt-4 md:mt-0'>
          <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>Line ID</span>
          <span className='flex w-full text-base font-medium leading-5  mt-1'>{ customerLine === '' ? '-' : customerLine  }</span>
        </div>
      </div>

      <div className='flex flex-wrap w-full mt-6 md:mt-8 border-t border-grey-500'>
      </div>


      <div className='flex-wrap w-full mt-6 md:mt-8'>
        <span className='flex w-full text-lg font-medium leading-6 '>รายละเอียดการเรียกร้องค่าสินไหม</span>
      </div>

      <div className='flex-wrap w-full  mt-6'>
          <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>ประเภทการเรียกร้องค่าสินไหม</span>
          <span className='flex w-full text-base font-medium leading-5  mt-1'>{CLAIM_TYPE(documentType, suffererType)}</span>
          <br/>
          <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>สถานะ</span>
      </div>



      {/* <div className='flex w-full  mt-4 md:mt-8 p-4 bg-yellow-400 rounded-lg'>
          <div className='flex-none'>
            <img src={iconWarning} alt="icon-warning" />
          </div>
          <div className='grow flex flex-wrap w-full pl-3'>
            <span className='flex w-full text-base font-medium leading-5 '>ต้องการเอกสาร เพิ่มเติม</span>
            <span className='flex w-full text-sm font-normal leading-5 text-grey-600'>สำเนาบัตรประชนผู้เอาประกัน รูปภาพ ความเสียหายในส่วนกันชนหน้าไม่ชัดเจน</span>
            <button 
                className={'w-[76px] mt-2 text-sm leading-5 font-medium py-1.5 px-3 rounded-lg border-radius-other-4px  '+ ( (false)? ' bg-grey-600 text-white ' : ' bg-green-500 text-white ')}>
                  อัพโหลด
            </button>
          </div>
      </div> */}
    {displayStatus.includes(1) ?  
      <div className='flex-wrap w-full  mt-8'>
        <div className='flex  w-full'>
          <div className='flex-none relative w-[24px]'>
            
            <div className='absolute top-0 left-0 right-0 mt-[18px] z-40 w-[24px] h-[24px]'>
              <img src={( isStatus01 !== '' ? iconActive : iconInActive )} alt="step-status"  className='w-[24px] h-[24px]'/>
            </div>
            <div className='absolute top-0 left-0 z-10 mt-[42px] px-[11px] h-full'>
              <div className={( isStatus02 || isStatus06 !== '' ? ' border-green-500 ' : ' border-grey-300 ' ) +' h-full border-r-[2px]  '}></div>
            </div>
          </div>
          <div className='grow flex-wrap w-full pl-4  py-1'>
            <span className={( isStatus01 !== '' ? '  text-green-500 ' : '  text-black ' )+'flex w-full text-sm font-normal leading-5'}>ตรวจสอบเอกสารของคุณ</span>
            <span className='flex w-full mt-1 text-sm font-normal leading-5 text-grey-600'>บริษัทฯ ได้รับเอกสารของคุณแล้ว และอยู่ในระหว่างการตรวจสอบเอกสาร</span>
            {
              isStatus01 !== '' ?
                <span className='flex w-full mt-1 text-xs font-normal leading-4 text-grey-800'>{ isStatus01 }</span>
              :
              null
            }

            <span className='flex w-full mt-1 text-xs font-normal leading-4 text-grey-800'></span>
            
          </div>
        </div>
      </div>
      : ''}

      {displayStatus.includes(2) ?  
        <div className='flex-wrap w-full'>
          <div className='flex w-full'>
            <div className='relative w-[24px]'>
              <div className='absolute w-[24px] h-[24px] top-0 left-0 right-0 mt-[18px] z-40 '>
                <img src={( isStatus02 !== '' ? iconActive : iconInActive )} alt="step-status"  className='w-[24px] h-[24px]'/>
              </div>
              <div className=' relative h-full px-[11px]'>

                <div className='absolute h-full top-0 left-0 z-10 px-[11px] '>
                  <div className={( isStatus03 || isStatus07 !== '' ? ' border-green-500 ' : ' border-grey-300 ' ) +'h-full border-r-[2px]  '}></div>
                </div>
                <div className='absolute h-1/3 top-0 left-0 z-10 px-[11px] '>
                  <div className={( isStatus02 !== '' ? ' border-green-500 ' : ' border-grey-300 ' ) +'h-full border-r-[2px]  '}></div>
                </div>
              </div>

            </div>
            <div className='flex flex-wrap w-full pl-4  py-2'>
            <span className={( isStatus02 !== '' ? '  text-green-500 ' : '  text-black ' )+'flex w-full text-sm font-normal leading-5'}>อยู่ระหว่างพิจารณาค่าสินไหม</span>
              <span className='flex w-full mt-1 text-sm font-normal leading-5 text-grey-600'>บริษัทฯ อยู่ในระหว่างการตรวจสอบข้อมูล และพิจารณาค่าสินไหม</span>
              {
                isStatus02 !== '' ?
                  <span className='flex w-full mt-1 text-xs font-normal leading-4 text-grey-800'>{ isStatus02 }</span>
                :
                null
              }
              <span className='flex w-full mt-1 text-xs font-normal leading-4 text-grey-800'></span>
              
            </div>
          </div>
        </div>
      : ''}


      {displayStatus.includes(3) ?  
        <div className='flex-wrap w-full'>
          <div className='flex w-full'>
            <div className='relative w-[24px]'>
              <div className='absolute w-[24px] h-[24px] top-0 left-0 right-0 mt-[18px] z-40 '>
                <img src={( isStatus03 !== '' ? iconActive : iconInActive )} alt="step-status"  className='w-[24px] h-[24px]'/>
              </div>
              <div className=' relative h-full px-[11px]'>

                <div className='absolute h-full top-0 left-0 z-10 px-[11px] '>
                  <div className={( isStatus04 || isStatus07 !== '' ? ' border-green-500 ' : ' border-grey-300 ' ) +'h-full border-r-[2px]  '}></div>
                </div>
                <div className='absolute h-1/3 top-0 left-0 z-10 px-[11px] '>
                  <div className={( isStatus03 !== '' ? ' border-green-500 ' : ' border-grey-300 ' ) +'h-full border-r-[2px]  '}></div>
                </div>
              </div>
            </div>
            <div className='flex flex-wrap w-full pl-4  py-2'>
            <span className={( isStatus03 !== '' ? '  text-green-500 ' : '  text-black ' )+'flex w-full text-sm font-normal leading-5'}>ขั้นตอนตกลงค่าสินไหม หรือ เจรจา</span>
              <span className='flex w-full mt-1 text-sm font-normal leading-5 text-grey-600'>บริษัทฯ จะส่ง SMS รายละเอียดค่าสินไหมให้คุณพิจารณา</span>
              {
                isStatus03 !== '' ?
                  <span className='flex w-full mt-1 text-xs font-normal leading-4 text-grey-800'>{ isStatus03 }</span>
                :
                null
              }
              
            </div>
          </div>
        </div>
      : ''}

      {displayStatus.includes(4) ?  
        <div className='flex-wrap w-full'>
          <div className='flex w-full'>
            <div className='relative w-[24px]'>
              <div className='absolute w-[24px] h-[24px] top-0 left-0 right-0 mt-[18px] z-40 '>
                <img src={( isStatus04 !== '' ? iconActive : iconInActive )} alt="step-status"  className='w-[24px] h-[24px]'/>
              </div>
              <div className=' relative h-full px-[11px]'>

                <div className='absolute h-full top-0 left-0 z-10 px-[11px] '>
                  <div className={( isStatus05 !== '' ? ' border-green-500 ' : ' border-grey-300 ' ) +'h-full border-r-[2px]  '}></div>
                </div>
                <div className='absolute h-1/3 top-0 left-0 z-10 px-[11px] '>
                  <div className={( isStatus04 !== '' ? ' border-green-500 ' : ' border-grey-300 ' ) +'h-full border-r-[2px]  '}></div>
                </div>
              </div>
            </div>
            <div className='flex flex-wrap w-full pl-4  py-2'>
            <span className={( isStatus04 !== '' ? '  text-green-500 ' : '  text-black ' )+'flex w-full text-sm font-normal leading-5'}>ตั้งเบิกค่าสินไหมให้แก่คุณ</span>
              <span className='flex w-full mt-1 text-sm font-normal leading-5 text-grey-600'>บริษัทฯ จะทำการนัดหมาย วันที่จ่ายค่าสินไหมให้กับคุณโดยเร็วที่สุด</span>
              {
                isStatus04 !== '' ?
                  <span className='flex w-full mt-1 text-xs font-normal leading-4 text-grey-800'>{ isStatus04 }</span>
                :
                null
              }
              
            </div>
          </div>
        </div>
      : ''}

      {displayStatus.includes(5) ?  
        <div className='flex-wrap w-full'>
          <div className='flex w-full'>
            <div className='relative w-[24px]'>
              <div className='absolute w-[24px] h-[24px] top-0 left-0 right-0 mt-[18px] z-40 '>
                <img src={( isStatus05 !== '' ? iconActive : iconInActive )} alt="step-status"  className='w-[24px] h-[24px]'/>
              </div>
              <div className='absolute top-0 left-0 z-10 px-[11px]'>
          
                <div className={( isStatus05 !== '' ? ' border-green-500 ' : ' border-grey-300 ' ) +' h-[38px] border-r-[2px]  '}></div>
              </div>
            </div>
            <div className='flex flex-wrap w-full pl-4  py-2'>
            <span className={( isStatus05 !== '' ? '  text-green-500 ' : '  text-black ' )+'flex w-full text-sm font-normal leading-5'}>จ่ายค่าสินไหม</span>
              <span className='flex w-full mt-1 text-sm font-normal leading-5 text-grey-600'>บริษัทฯ ได้จ่ายชดเชยค่าสินไหมให้กับคุณเป็นที่เรียบร้อยแล้ว</span>
              {
                isStatus05 !== '' ?
                  <span className='flex w-full mt-1 text-xs font-normal leading-4 text-grey-800'>{ isStatus05 }</span>
                :
                null
              }
              
            </div>
          </div>
        </div>
      : ''}

      {displayStatus.includes(6) ?  
        <div className='flex-wrap w-full'>
          <div className='flex w-full'>
            <div className='relative w-[24px]'>
              <div className='absolute w-[24px] h-[24px] top-0 left-0 right-0 mt-[18px] z-40 '>
                <img src={( isStatus06 !== '' ? iconActive : iconInActive )} alt="step-status"  className='w-[24px] h-[24px]'/>
              </div>
              <div className='absolute top-0 left-0 z-10 px-[11px]'>
          
                <div className={( isStatus06 !== '' ? ' border-green-500 ' : ' border-grey-300 ' ) +' h-[38px] border-r-[2px]  '}></div>
              </div>
            </div>
            <div className='flex flex-wrap w-full pl-4  py-2'>
            <span className={( isStatus06 !== '' ? '  text-green-500 ' : '  text-black ' )+'flex w-full text-sm font-normal leading-5'}>สอบถามสถานะเพิ่มเติม</span>
              <span className='flex w-full mt-1 text-sm font-normal leading-5 text-grey-600'>บริษัทฯ อยู่ในระหว่างการพิจารณารายการซ่อมของคุณ คุณสามารถ</span>
              <span className='flex w-full mt-1 text-sm font-normal leading-5 text-grey-600'>สอบถามสถานะเพิ่มเติมกับเจ้าหน้าที่ ติดต่อ</span>
              <span className='flex w-full mt-1 text-sm font-normal leading-5 text-grey-600'>โทร 1231ต่อ 3911/3917/3918</span>
              <span className='flex w-full mt-1 text-sm font-normal leading-5 text-grey-600'>อีเมล์&nbsp;<a className='text-[#0052CC]' href="mailto:enquiry-pricing-motor@thaivivat.co.th">enquiry-pricing-motor@thaivivat.co.th</a></span>
 
              
            </div>
          </div>
        </div>
      : ''}

      {displayStatus.includes(7) ?  
        <div className='flex-wrap w-full'>
          <div className='flex w-full'>
            <div className='relative w-[24px]'>
              <div className='absolute w-[24px] h-[24px] top-0 left-0 right-0 mt-[18px] z-40 '>
                <img src={( isStatus07 !== '' ? iconActive : iconInActive )} alt="step-status"  className='w-[24px] h-[24px]'/>
              </div>
              <div className='absolute top-0 left-0 z-10 px-[11px]'>
          
                <div className={( isStatus07 !== '' ? ' border-green-500 ' : ' border-grey-300 ' ) +' h-[38px] border-r-[2px]  '}></div>
              </div>
            </div>
            <div className='flex flex-wrap w-full pl-4  py-2'>
            <span className={( isStatus07 !== '' ? '  text-green-500 ' : '  text-black ' )+'flex w-full text-sm font-normal leading-5'}>ออกหนังสือผลพิจารณา</span>
              <span className='flex w-full mt-1 text-sm font-normal leading-5 text-grey-600'>ผลพิจารณาของคุณเสร็จสิ้นแล้ว บริษัทจะทำการออกหนังสือแจ้งผลพิจารณาให้คุณทราบ ภายใน 3 วันทำการ</span>
              {
                isStatus07 !== '' ?
                  <span className='flex w-full mt-1 text-xs font-normal leading-4 text-grey-800'>{ isStatus07 }</span>
                :
                null
              }
              
            </div>
          </div>
        </div>
      : ''}

    </div>
  )
}

export default TrackingDetailComponent;